import { LicenseInfo } from "@mui/x-data-grid-pro";

export function getDatagridLicenseKeyFromEnv(): string | undefined {
  return process.env.REACT_APP_MUI_DATAGRID_LICENSE_KEY || undefined;
}

export function hasDatagridLicenseKeyInEnv(): boolean {
  return !!getDatagridLicenseKeyFromEnv();
}

export function ensureMuiDataGridLicense(key?: string): void {
  const licenseKey = key ?? getDatagridLicenseKeyFromEnv();
  if (!licenseKey) return;
  LicenseInfo.setLicenseKey(licenseKey);
}
